if (!customElements.get('os-video-banner')) {
  class OsVideoBanner extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.video.addEventListener('playing', () => this.video.classList.add('is-playing'), { once: true });
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          }
        },
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('os-video-banner', OsVideoBanner);
}
